import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PathViewComponent } from './path-view/path-view.component';
import { WaypointListComponent } from './waypoint-list/waypoint-list.component';
import { PathListComponent } from './path-list/path-list.component';
import { SharedModule } from '../shared/shared.module';
import { CoreModule } from '../core/core.module';
import { TaskModule } from '../task/task.module'
import { RouterModule } from '@angular/router';
import { WaypointsPlotterComponent } from './waypoints-plotter/waypoints-plotter.component'
import { WaypointMarkerPopupComponent } from './waypoints-plotter/waypoint-marker-popup/waypoint-marker-popup.component'
import { createCustomElement } from '@angular/elements';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ScoutModule } from '../scout/scout.module';
import { PathScoutSourceComponent } from './path-scout-source/path-scout-source.component'
import { PathKmlViewerComponent } from './path-kml-viewer/path-kml-viewer.component';
import { PathKmlViewerModal } from './path-kml-viewer/path-kml-viewer-modal/path-kml-viewer-modal.component';
import { FormsModule } from '@angular/forms';
import { NgPipesModule } from 'ngx-pipes';

@NgModule({
  declarations: [
    PathViewComponent,
    WaypointListComponent,
    PathListComponent,
    WaypointsPlotterComponent,
    WaypointMarkerPopupComponent,
    PathScoutSourceComponent,
    PathKmlViewerModal,
    PathKmlViewerComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    SharedModule,
    TaskModule,
    RouterModule,
    LeafletModule,
    ScoutModule,
    NgPipesModule,
  ],
  exports: [
    PathViewComponent,
    WaypointListComponent,
    PathListComponent,
    PathScoutSourceComponent,
    WaypointsPlotterComponent
  ],
  entryComponents: [ WaypointMarkerPopupComponent ]
})
export class PathModule {
  constructor(private injector: Injector) {
    const popupElement = createCustomElement(WaypointMarkerPopupComponent, {injector});
    customElements.define('app-waypoint-marker-popup-element', popupElement);
  }
}

